/* eslint-disable array-callback-return */
import { Modal, Space, message } from 'antd'
import React from 'react'
import { useTradeModalStore } from '../hooks/trade/modalStore'
import TextArea from 'antd/es/input/TextArea'
import { useToken } from '../hooks'
import API from '../../utils/api'

export const SendModal = () => {
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()
	const { data: token } = useToken()
	const [content, setContent] = React.useState('')
	return (
		<Modal
			open={modalStore?.sendmodal}
			cancelText="취소"
			okText="전송"
			onOk={() => {
				API.send('POST', '/admin/notification', token + '', {
					sender: modalStore?.sendtarget,
					type: 2,
					group_id: modalStore?.sendtargetid,
					user_id: modalStore?.sendtargetid,
					title: '관리자 메시지',
					content: content,
				}).then(res => {
					message.success('메시지 전송 완료')
					mutateModalStore({
						...modalStore,
						sendmodal: false,
					})
				})
			}}
			onCancel={() => {
				mutateModalStore({
					...modalStore,
					sendmodal: false,
				})
			}}>
			<Space direction="vertical" style={{ width: '100%' }}>
				<Space>
					대상:{' '}
					{modalStore?.sendtarget == 'all'
						? '전체'
						: modalStore?.sendtarget == 'user'
						? `회원(${modalStore?.sendtargetid}번)`
						: `그룹(${modalStore?.sendtargetid}번)`}
				</Space>
				<Space style={{ width: '100%' }}>
					<div>메시지전송</div>
				</Space>
				<TextArea
					style={{ width: '100%', flex: 1 }}
					size="large"
					value={content}
					onChange={e => {
						setContent(e.target.value)
					}}
				/>
			</Space>
		</Modal>
	)
}
